import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';

import * as Client from '@vi-iot/client';
import {
  CompanyResponseModel,
  ConnectivityRanking,
  SubscriptionWithPaidFeatures,
} from '@vi-iot/client';
import { IAMRoles } from '../_enums';

export namespace AuthActions {
  export const startAuthFlow = createAction(
    '[AUTH] Start Auth Flow',
    props<{ repeatedAfter401: boolean }>()
  );

  export const showLandingPage = createAction('[AUTH] SHOW_LANDING_PAGE');

  export const getCSRFTokenFromStorage = createAction(
    '[AUTH] Get CSRF Token From Storage',
    props<{ repeatedAfter401: boolean }>()
  );

  export const getMe = createActionGroup({
    source: 'AUTH Get Me',
    events: {
      attempt: props<{ repeatedAfter401: boolean; isCSRF: boolean }>(),
      success: props<{ me: Client.LoggedInUserDetails }>(),
      error: props<{
        statusCode: number;
        repeatedAfter401: boolean;
        isCSRF: boolean;
      }>(),
    },
  });

  export const navigateToForbiddenPage = createAction('[AUTH] Navigate to forbidden page');

  export const authorizeMe = createAction(
    '[AUTH] Authorize Me',
    props<{
      roleGroup: Client.RoleGroupType;
      businessRoles: string[];
      identityType: IAMRoles;
    }>()
  );

  export const updateEmail = createAction('[AUTH] Update Email', props<{ email: string }>());

  export const updatePhone = createAction('[AUTH] Update Phone', props<{ phone: string }>());

  export const logout = createAction('[AUTH] Logout');

  export const runDemo = createAction('[AUTH] Run Demo');

  export const exitDemo = createAction('[AUTH] Exit Demo');

  export const learningRoomBanner = createActionGroup({
    source: 'AUTH Learning Room Banner',
    events: {
      'show attempt': emptyProps(),
      'show success': props<{ isActive: boolean }>(),
      'close attempt': emptyProps(),
      'close success': emptyProps(),
    },
  });

  export const eventBanner = createActionGroup({
    source: 'AUTH Event Banner',
    events: {
      'show attempt': emptyProps(),
      'show success': props<{ isActive: boolean }>(),
      'close attempt': emptyProps(),
      'close success': emptyProps(),
    },
  });

  export const paidFeaturesBanner = createActionGroup({
    source: 'AUTH Paid Features Banner',
    events: {
      'show attempt': emptyProps(),
      'show success': props<{ isActive: boolean }>(),
      'close attempt': emptyProps(),
      'close success': emptyProps(),
    },
  });

  export const readCompanyPaidFeatures = createActionGroup({
    source: 'AUTH Read Company Paid Features',
    events: {
      success: props<{ subscriptionWithPaidFeatures: SubscriptionWithPaidFeatures }>(),
      attempt: emptyProps(),
      error: emptyProps(),
    },
  });

  export const getConnectivityRanking = createActionGroup({
    source: 'AUTH Get connectivity ranking',
    events: {
      success: props<{ connectivityRanking: ConnectivityRanking }>(),
      error: emptyProps(),
    },
  });

  export const authenticateMe = createActionGroup({
    source: 'AUTH Authenticate me',
    events: {
      attempt: emptyProps(),
      success: emptyProps(),
      error: props<{ error: Client.ViError }>(),
    },
  });

  export const iframeRefreshToken = createAction('[AUTH] Refresh token');

  export const getUserCompany = createActionGroup({
    source: 'AUTH Get user company',
    events: {
      attempt: emptyProps(),
      success: props<{ data: CompanyResponseModel }>(),
      error: props<{ error: Client.ViError }>(),
    },
  });

  export const useRefreshToken = createAction('[AUTH] Use refresh token');

  export const refreshTokenOn401Error = createAction('[AUTH] Use refresh token on 401 error');
}
